import { Box, Flex, IconButton, Tooltip, Icon } from "@chakra-ui/react";
import { useState, useCallback, useRef, useEffect } from "react";
import { Monitor } from "./Monitor";
import { ChatPanel } from "../../components/ChatDrawer/chat";
import { BsStars, BsX } from "react-icons/bs";

export const MonitorLayout = () => {
  const [leftWidth, setLeftWidth] = useState(75);
  const [isDragging, setIsDragging] = useState(false);
  const [isAiAssistantOpen, setIsAiAssistantOpen] = useState(true);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleMouseDown = useCallback(() => {
    setIsDragging(true);
  }, []);

  const handleMouseMove = useCallback(
    (e: MouseEvent) => {
      if (!isDragging || !containerRef.current) return;
      const containerRect = containerRef.current.getBoundingClientRect();
      const mouseX = e.clientX - containerRect.left;
      const newLeftWidth = (mouseX / containerRect.width) * 100;
      const constrainedWidth = Math.min(Math.max(newLeftWidth, 20), 80);
      setLeftWidth(constrainedWidth);
    },
    [isDragging]
  );

  const handleMouseUp = useCallback(() => {
    setIsDragging(false);
  }, []);

  useEffect(() => {
    if (isDragging) {
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
      document.body.style.cursor = "col-resize";
      document.body.style.userSelect = "none";
    } else {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
    }

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
    };
  }, [isDragging, handleMouseMove, handleMouseUp]);

  return (
    <>
      <Flex
        ref={containerRef}
        h="88.5vh"
        w="100%"
        overflow="hidden"
        position="relative"
      >
        {/* Left Panel - Monitor */}
        <Box
          width={"100%"}
          overflowY="auto"
          bg="transparent"
          p={4}
          transition={isDragging ? "none" : "width 0.3s ease"}
          position="relative"
          zIndex="1"
        >
          <Monitor />
        </Box>
      </Flex>
    </>
  );
};
